// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-module--footer--1lE8L"};